module.exports = __webpack_public_path__ + "static/media/icon_2.9b639285.svg";